import { takeLatest, call, put, select } from "redux-saga/effects"
import { GET_UPLOAD_FILE_STATUS_REQUEST, GET_UPLOAD_SUPPORTED_FILE_FORMAT_REQUEST, POST_UPLOAD_FILE_REQUEST } from "../types"
import {
	getUploadFileFormatFailed,
	getUploadFileFormatSuccess,
	getUploadFileStatusFailed,
	getUploadFileStatusSuccess,
	uploadFileFailed,
	uploadFileSuccess,
} from "../actions/uploadActions"
import { setNotification } from "../actions/notificationActions"
import { uploadServices } from "../services/upload.services"
import { CLIENT_SIDE_MESSAGES as Messages } from "../utils"

function* getUploadFileFormatSaga() {
	try {
		const result = yield call(uploadServices.getUploadFileFormat)
		if (result?.status === 200 && result?.data?.success === true) {
			const formats = result?.data?.data
			const tooltip = result?.data?.data
			yield put(getUploadFileFormatSuccess({ formats, tooltip }))
		} else {
			yield put(getUploadFileFormatFailed(result?.data?.message))
		}
	} catch (error) {
		yield put(getUploadFileFormatFailed(Messages.SERVER_ERROR))
	}
}

function* uploadFileRequestSaga(action) {
	try {
		const data = action?.payload
		const case_id = yield select((state) => state.multiBase.selectedBase.project_id)
		const result = yield call(uploadServices.uploadFiles, data, case_id)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(uploadFileSuccess(data))

			if (result?.data?.data?.bifrost_job_details?.success === false) {
				yield put(
					setNotification({
						data:
							result?.data?.data?.bifrost_job_details?.message ||
							"New job could not be added to the case as case is not in 'IDLE' state.",
						severity: "error",
					})
				)
			}
		} else {
			yield put(uploadFileFailed(result?.data?.message))
			yield put(setNotification({ data: result?.data?.message, severity: "error" }))
		}
	} catch (error) {
		yield put(uploadFileFailed(error))
		yield put(setNotification({ data: error, severity: "error" }))
	}
}

const demoNotifications = [
	{
		message: "test.txt",
		variant: "success",
	},
	{
		message: "myfile.txt",
		variant: "error",
	},
	{
		message: "this is new.pdf",
		variant: "success",
	},
	{
		message: "test.txt",
		variant: "error",
	},
]

function* getUploadFileStatusSaga() {
	try {
		const result = yield call(uploadServices.getUploadFileStatus)
		if (result?.status === 200 && result?.data?.success === true) {
			const data = result?.data?.data
			if (data?.status === "Active") {
				const notifications = []
				const files = data?.files || {}
				if (!_.isEmpty(files)) {
					for (const property in files) {
						notifications.push({
							variant: files[property] === true ? "success" : "error",
							message: property,
						})
					}
				}
				yield put(getUploadFileStatusSuccess(notifications))
			} else {
				yield put(getUploadFileStatusFailed(data))
			}
		} else {
			yield put(getUploadFileStatusFailed(result?.data?.message))
		}
	} catch (error) {
		yield put(getUploadFileStatusFailed(Messages.SERVER_ERROR))
	}
}

export default function* uploadSagas() {
	yield takeLatest(GET_UPLOAD_SUPPORTED_FILE_FORMAT_REQUEST, getUploadFileFormatSaga)
	yield takeLatest(POST_UPLOAD_FILE_REQUEST, uploadFileRequestSaga)
	yield takeLatest(GET_UPLOAD_FILE_STATUS_REQUEST, getUploadFileStatusSaga)
}
